// Demo albums data for local development without Spotify API
export const demoProfile = {
  display_name: "Demo User",
  external_urls: {
    spotify: "https://open.spotify.com/user/demo",
  },
};

export const demoAlbums = [
  // Albums
  {
    album: {
      id: "demo1",
      name: "Fine Art",
      release_date: "2024-06-14",
      release_date_precision: "day",
      album_type: "album",
      artists: [
        {
          id: "artist1",
          name: "Kneecap",
          external_urls: {
            spotify: "https://open.spotify.com/artist/1ZVACPeq7ccGCoUXwtafUU",
          },
        },
      ],
      images: [
        {
          url: "https://i.scdn.co/image/ab67616d0000b273385bd4740ec9be7ec79d6851",
          width: 640,
          height: 640,
        },
        {
          url: "https://i.scdn.co/image/ab67616d00001e02385bd4740ec9be7ec79d6851",
          width: 300,
          height: 300,
        },
        {
          url: "https://i.scdn.co/image/ab67616d00004851385bd4740ec9be7ec79d6851",
          width: 64,
          height: 64,
        },
      ],
      external_urls: {
        spotify: "https://open.spotify.com/artist/3Rj0tDHoX7C5NFq5DKIpHt",
      },
    },
  },
  {
    album: {
      id: "demo2",
      name: "Dots And Loops (Extended Edition)",
      release_date: "1997",
      release_date_precision: "year",
      album_type: "album",
      artists: [
        {
          id: "artist2",
          name: "Stereolab",
          external_urls: {
            spotify: "https://open.spotify.com/artist/6qqNVTkY8uBg9cP3Jd8DAH",
          },
        },
      ],
      images: [
        {
          url: "https://i.scdn.co/image/ab67616d0000b2735e70712e0193f7a9bbc23c0d",
          width: 640,
          height: 640,
        },
        {
          url: "https://i.scdn.co/image/ab67616d0000e1a35e70712e0193f7a9bbc23c0d",
          width: 300,
          height: 300,
        },
        {
          url: "https://i.scdn.co/image/ab67616d000048515e70712e0193f7a9bbc23c0d",
          width: 64,
          height: 64,
        },
      ],
      external_urls: {
        spotify: "https://open.spotify.com/album/151mT9g0fDHVfpmWeYk4Wx",
      },
    },
  },
  {
    album: {
      id: "demo4",
      name: "Face Down In The Garden",
      release_date: "2025-04-25",
      release_date_precision: "day",
      album_type: "album",
      artists: [
        {
          id: "artist3",
          name: "Tennis",
          external_urls: {
            spotify: "https://open.spotify.com/artist/1ybAN3utgdoUL1MUCtH4QM",
          },
        },
      ],
      images: [
        {
          url: "https://i.scdn.co/image/ab67616d0000b27398eed948ea0588bec5ce9321",
          width: 640,
          height: 640,
        },
        {
          url: "https://i.scdn.co/image/ab676d63000076a038be10bb9ae967b11af8db32",
          width: 300,
          height: 300,
        },
        {
          url: "https://i.scdn.co/image/ab67616d0000485198eed948ea0588bec5ce9321",
          width: 64,
          height: 64,
        },
      ],
      external_urls: {
        spotify: "https://open.spotify.com/album/1c1fQu7fCCaB4gIwttv6ZN",
      },
    },
  },
  {
    album: {
      id: "demo4",
      name: "NA HALF 1",
      release_date: "2025-01-26",
      release_date_precision: "day",
      album_type: "album",
      artists: [
        {
          id: "artist3",
          name: "Chibi Ichigo",
          external_urls: {
            spotify: "https://open.spotify.com/artist/0eARdjFMVY4Z92QEzM7dgN",
          },
        },
      ],
      images: [
        {
          url: "https://i.scdn.co/image/ab67616d0000b273c9cb50ada50196a75085f153",
          width: 640,
          height: 640,
        },
        {
          url: "https://i.scdn.co/image/ab67616d00001e02c9cb50ada50196a75085f153",
          width: 300,
          height: 300,
        },
      ],
      external_urls: {
        spotify: "https://open.spotify.com/album/6xsTEk2rQoDR2UbMrfKU0Z",
      },
    },
  },

  // Single
  {
    album: {
      id: "demo9",
      name: "Cut & Rewind",
      release_date: "2025-06-17",
      release_date_precision: "day",
      album_type: "single",
      artists: [
        {
          id: "artist1",
          name: "Say She She",
          external_urls: {
            spotify: "https://open.spotify.com/artist/1WGb8nCPGJA0RyriSDIQfC",
          },
        },
      ],
      images: [
        {
          url: "https://i.scdn.co/image/ab67616d0000b2738fccab8d8765d9551c21bd66",
          width: 640,
          height: 640,
        },
        {
          url: "https://i.scdn.co/image/ab67616d00001e02c6aeec40a5b555c715b00b6d",
          width: 300,
          height: 300,
        },
      ],
      external_urls: {
        spotify: "https://open.spotify.com/album/50tyh4co58xNd1C1N4mq4k",
      },
    },
  },

  // Compilation
  {
    album: {
      id: "demo10",
      name: "Best of Bowie",
      release_date: "2002-10-21",
      release_date_precision: "day",
      album_type: "compilation",
      artists: [
        {
          id: "artist8",
          name: "David Bowie",
          external_urls: {
            spotify: "https://open.spotify.com/artist/0oSGxfWSnnOXhD2fKuz2Gy",
          },
        },
      ],
      images: [
        {
          url: "https://i.scdn.co/image/ab67616d0000b27398dc2963e511c2ff25475d03",
          width: 640,
          height: 640,
        },
        {
          url: "https://i.scdn.co/image/ab67616d0000e1a398dc2963e511c2ff25475d03",
          width: 300,
          height: 300,
        },
      ],
      external_urls: {
        spotify: "https://open.spotify.com/album/0wdWjBb23leDF11YND4kQd",
      },
    },
  },
];
